<template>
  <div class="products">
    <div
      class="caixa_produtos"
      v-for="(item, index) of this.objProducts"
      :key="index"
    >
      <div
        class="row chamada_categoria cat_familia mb-4 justify-content-center"
      >
        <h3>{{ item.categoria }}</h3>
        <hr />
      </div>
      <div class="lista_produtos">
        <div class="row">
          <div
            class="col-xl-2 col-lg-3 col-md-4"
            v-for="produto of item.produtos"
            v-bind:class="[item.produtos.length === 1 ? 'col-12' : 'col-6']"
            :key="produto.id"
          >
            <div
              class="item_produto item_semestral"
              @click="
                detailsProduct(
                  produto,
                  !(produto.qtdEstoque > 0) && controleEstoque
                )
              "
              :class="{
                esgotado: !(produto.qtdEstoque > 0) && controleEstoque,
              }"
            >
              <div class="tagEsgotado">Esgotado</div>
              <div class="titulo_categoria ellipsis">
                <div :style="{ 'background-image': urlImage(produto) }"></div>
                <span class="justify-content-center">{{ produto.nome }}</span>
              </div>
              <div class="tamanho-valor">
                <div class="valor row m-1">
                  <span class="preco">{{ produto.preco | currency }} </span>
                  <span class="preco"> &nbsp;{{ produto.unidadeMedida }}</span>
                  <span class="a-vista  float-left p-2">à vista</span>
                </div>
                <div class="valor" v-if="produto.qtdParcelas > 1">
                  <span class="a-prazo"
                    >ou {{ produto.valorPrazo | currency }}
                  </span>
                  <span class="parcelas"
                    >{{ produto.qtdParcelas }}x de
                    {{ produto.valorParcela | currency }} s/juros</span
                  >
                </div>
              </div>
              <a
                class="btn_selecionar"
                data-toggle="modal"
                data-target="#modalProduto"
                >Comprar</a
              >
              <a class="btn_selecionar disabled">INDISPONÍVEL</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Products",
  props: {
    objProducts: Array,
  },
  data() {
    return {
      objDetalhes: { idProduto: 0, quantidade: 0, objProduto: {} },
      controleEstoque: window.CONTROLE_ESTOQUE,
    };
  },
  mounted() {},
  methods: {
    detailsProduct(produto, isDisabled) {
      if (!isDisabled) {
        this.objDetalhes.idProduto = produto.id;
        this.objDetalhes.objProduto = produto;
        this.objDetalhes.toggleModal = true;
        this.$emit("modificaDetalhes", this.objDetalhes);
      }
    },
    urlImage(produto) {
      return `url('${produto.imagemUrl ||
        "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png"}')`;
    },
  },
};
</script>

<style scoped lang="scss">
.chamada_categoria {
  max-height: 100px;
}
.chamada_categoria h3 {
  font-weight: 400;
  margin-top: 0.2rem;
  font-size: 2em;
}
.chamada_categoria p {
  font-size: 1.2rem;
  padding: 0 1rem;
}
.chamada_categoria.cat_familia h3 {
  color: var(--cor-principal);
  font-size: 1.3rem;
  margin: 0 8px;
}
.chamada_categoria.cat_familia hr {
  border: 0;
  display: flex;
  flex: 1;
  background: var(--cor-secundaria);
  height: 2px;
  position: relative;
}

.chamada_categoria.cat_familia hr:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: #01010100;
  background: -webkit-linear-gradient(left, #01010100, #ffffff);
  background: -moz-linear-gradient(left, #01010100, #ffffff);
  background: linear-gradient(to right, #01010100, #ffffff);
  width: 100%;
  height: 100%;
}

.chamada_categoria.cat_atleta h3 {
  color: #1d4f91;
}
.caixa_produtos {
  margin-bottom: 1rem;
}
.imgCategoria {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 300px;
}
.item_produto {
  cursor: pointer;
}
.item_produto .disabled {
  display: none !important;
  background: #cacaca;
  border-color: #cacaca;
}
.item_produto .tagEsgotado {
  background-color: var(--cor-secundaria);
  color: #fff;
  padding: 4px 32px;
  border-radius: 50px 0 0 50px;
  margin: 0 16px;
  position: absolute;
  z-index: 1;
  right: 0;
  display: none;
}
.item_produto.esgotado .tagEsgotado {
  display: initial;
}
.item_produto.esgotado .disabled {
  display: block !important;
}
.item_produto.esgotado .btn_selecionar:not(.disabled) {
  display: none !important;
}
.item_produto.esgotado .valor *,
.item_produto.esgotado span {
  color: #cacaca !important;
}
.item_produto.esgotado .titulo_categoria {
  filter: opacity(0.3);
}
</style>
